import React from 'react';
import '../css/Section.css';

function BenefitsSection() {
  const benefits = [
    {
      title: 'Store the Surplus',
      text: 'Automatically save excess solar generation during peak sunlight hours instead of letting it go to waste.'
    },
    {
      title: 'Seamless Independence',
      text: 'Access clean electricity day or night, keeping your household running smoothly when the grid drops.'
    },
    {
      title: 'Smart Economics',
      text: 'Aevolt Everflow dynamically balances your usage to shrink your carbon footprint and drop your monthly power bills.'
    }
  ];

  return (
    <section className="section dark-section">
      <div className="section-center">
        <p className="eyebrow">Adaptive Power</p>
        <h2>Power built around your life</h2>
        <div className="benefit-grid">
          {benefits.map((item, index) => (
            <div className="benefit-card" key={index}>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default BenefitsSection;
